import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MyUploadAdapter } from './MyUploadAdapter'
import TextField from '@material-ui/core/TextField'
import { useState } from 'react';


const EditorField = ({form, field, onUpload}) => {
    const {errors, touched} = form
    const {name} = field
    const isShowError = errors[name] && touched[name];
    const [data, setData] = useState(field.value)

    const onEdit = ( event, editor ) => {
        setData(editor.getData())
        const data = editor.getData();
        form.setFieldValue(name, data)
    } 

    return (
        <>
            
            <CKEditor
                editor={ ClassicEditor }
                data={data}
                onReady={ editor => {
                        if(!editor) return;
                        editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
                            loader.on('change:uploadedPercent', (evt, name, val, oldval) => {
                                onUpload(val < 100)
                            })
                        return new MyUploadAdapter(loader);

                        
                    }
                } }

                config={{ckfinder: {
                    uploadUrl: `${process.env.REACT_APP_BASE_URL_SERVER}/api/news/upload`
                }}}

                onChange={onEdit}
            />
            <TextField
                style={{width: '100%'}}
                {...field}
                error={isShowError}
                type="hidden"
                helperText={isShowError && errors[name]}
            />
        </>
    )
}

export default EditorField
